import { Grid, Button, useTheme } from "@mui/material";

export default function FilterButtons({
  onSelectFilterClick,
  onSaveFilterClick,
  isFilterEmpty,
}) {
  const theme = useTheme();
  return (
    <>
      <Grid item>
        <Button
          variant="outlined"
          color="primary"
          onClick={onSelectFilterClick}
          sx={{
            color: theme.palette.mode === "dark" ? "#fff" : "primary",
            borderColor: theme.palette.mode === "dark" ? "#fff" : "primary",
            "&:hover": {
              borderColor: theme.palette.mode === "dark" ? "#fff" : "primary",
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          Select Filter
        </Button>
      </Grid>
      <Grid item>
        <Button
          variant="outlined"
          color="primary"
          onClick={onSaveFilterClick}
          disabled={isFilterEmpty}
          sx={{
            color: theme.palette.mode === "dark" ? "#fff" : "primary",
            borderColor: theme.palette.mode === "dark" ? "#fff" : "primary",
            "&:hover": {
              borderColor: theme.palette.mode === "dark" ? "#fff" : "primary",
              backgroundColor: theme.palette.action.hover,
            },
          }}
        >
          Save Filter
        </Button>
      </Grid>
    </>
  );
}
